"use client";
import { useMediaQuery } from "react-responsive";
import brandsData from "./brandsData";
import BrandsDesktop from "./Desktop/BrandsDesktop";
import BrandsMobile from "./Mobile/BrandsMobile";

const Brands = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <section className="py-8">
      <div className="container">
        <div className="-mx-4">
          <div className="w-full px-4">
            <div className="rounded-sm bg-gray-light px-8 py-10 dark:bg-gray-dark">
              {isMobile ? (
                <BrandsMobile brandsData={brandsData} />
              ) : (
                <BrandsDesktop brandsData={brandsData} />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;